/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type ConfigurationType = "MeetingColors" | "PersonalCalendarSync" | "SettingUpTeam" | "SettingUpWorkingHours" | "ShadowCalendar" | "SlackStatusSync" | "TravelTime" | "%future added value";
export type TipType = "CheckOutProfile" | "CheckOutRescheduler" | "CheckOutTeamDashboard" | "FeedWelcome" | "%future added value";
export type SuggestionBody_suggestionPayload = {
    readonly __typename: string;
    readonly tipType?: TipType | null | undefined;
    readonly configurationType?: ConfigurationType | null | undefined;
    readonly " $fragmentRefs": FragmentRefs<"SuggestionBodyAutopilot_suggestionPayload" | "SuggestionBodyConflictingMeeting_suggestionPayload" | "SuggestionBodyExpensiveMeeting_suggestionPayload" | "SuggestionBodyExpensiveOrganizer_suggestionPayload" | "SuggestionBodyLowFocusTime_suggestionPayload" | "SuggestionBodyOutOfOffice_suggestionPayload" | "SuggestionBodyWeekInReview_suggestionPayload" | "SuggestionBodyWeeklyAutopilotSummary_suggestionPayload">;
    readonly " $refType": "SuggestionBody_suggestionPayload";
};
export type SuggestionBody_suggestionPayload$data = SuggestionBody_suggestionPayload;
export type SuggestionBody_suggestionPayload$key = {
    readonly " $data"?: SuggestionBody_suggestionPayload$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"SuggestionBody_suggestionPayload">;
};



const node: ReaderFragment = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "SuggestionBody_suggestionPayload",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "SuggestionBodyAutopilot_suggestionPayload"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "SuggestionBodyConflictingMeeting_suggestionPayload"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "SuggestionBodyExpensiveMeeting_suggestionPayload"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "SuggestionBodyExpensiveOrganizer_suggestionPayload"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "SuggestionBodyLowFocusTime_suggestionPayload"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "SuggestionBodyOutOfOffice_suggestionPayload"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "SuggestionBodyWeekInReview_suggestionPayload"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "SuggestionBodyWeeklyAutopilotSummary_suggestionPayload"
        },
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "tipType",
                    "storageKey": null
                }
            ],
            "type": "SuggestionResultChromeExtensionTipPayload",
            "abstractKey": null
        },
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "configurationType",
                    "storageKey": null
                }
            ],
            "type": "SuggestionResultMissingUserConfigurationPayload",
            "abstractKey": null
        }
    ],
    "type": "SuggestionResultPayload",
    "abstractKey": "__isSuggestionResultPayload"
} as any;
(node as any).hash = '82ef2fbd33306cf19dd8af06ca7183fc';
export default node;
